import { createContext, FC, useCallback, useContext, useState } from 'react';

export type ViewMode = 'accommodation' | 'total';

type EditorContext = {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
};

const RoomRatesEditorContext = createContext<EditorContext>({
  viewMode: 'accommodation',
  setViewMode: () => {},
});

export const useRoomRatesEditor = () => useContext(RoomRatesEditorContext);

const RoomRatesEditor: FC = ({ children }) => {
  const [viewMode, setViewMode] = useState<ViewMode>(
    (localStorage.getItem('roomRatesViewMode') as ViewMode) ?? 'accommodation'
  );

  const changeViewMode = useCallback((mode: ViewMode) => {
    setViewMode(mode);
    localStorage.setItem('roomRatesViewMode', mode);
  }, []);

  return (
    <RoomRatesEditorContext.Provider
      value={{ viewMode, setViewMode: changeViewMode }}>
      {children}
    </RoomRatesEditorContext.Provider>
  );
};

export default RoomRatesEditor;
